export default "__VITE_PUBLIC_ASSET__30df842b__"